import { useEffect, useState } from "react";
import { Accordion, Card, Modal } from "react-bootstrap"
import { useParams } from "react-router-dom";
import { dataDecrypt, encrypt } from "../../../../app/utility/encryption-helper";
import { ApisService } from "../../../../app/core/apis.service";
import { TiTick } from "react-icons/ti";
import { FormatIndianDate } from "../../../../app/utility/formatIndianDate";
import { IMAGE_PATH } from "../../../../config";

export const BuDetails = () => {
    const params = useParams();
    const [loading, setLoading] = useState<any>();
    const [rolesData, setRolesData] = useState<any>();
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        getExternalBuData();
    }, []);
    async function getExternalBuData(): Promise<void> {
        setLoading(true);
        try {
            let payload = {
                id: params.org,
            };
            let encryptedData = encrypt(JSON.stringify(payload));
            const apiRes = await ApisService.getOrganizationData("findById", encryptedData);
            const buData = JSON.parse(dataDecrypt(apiRes.data.data));
            setRolesData(buData[0]);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const closePopup=()=>{
        setShow(false);
    }

    const openPopup=()=>{
        setShow(true);
    }
    return (
        <div>
            <div className="mb-2">
                <h5 className="mt-3 mb-2 fw-bold">Details</h5>
                <Card>
                    <Card.Body className="py-2">
                        <div className="row align-items">
                            <div className="col-md-3 mb-2">
                                <div className="fw-bold">Logo</div>
                                <img src={IMAGE_PATH +'/'+ rolesData?.bu_logo_image} className="w-100-h-100 rounded-circle cursor-pointer" onClick={()=>openPopup()}/>
                            </div>
                            <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Bu Name</div>
                                <div>{rolesData?.business_name}</div>
                            </div>
                            <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Head of business</div>
                                <div>{rolesData?.head_of_business}</div>
                            </div>
                            <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Contact number</div>
                                <div>{rolesData?.mobile_number}</div>
                            </div>
                            <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Register Date</div>
                                <div>{FormatIndianDate(rolesData?.created_date, "dateWithTime")}</div>
                            </div>
                             <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Bu Id</div>
                                <div>{rolesData?._id}</div>
                            </div>
                            {rolesData?.GST_No && <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">GST No</div>
                                <div>{rolesData?.GST_No}</div>
                            </div>}
                            <div className="col-md-3 lh-1-5 my-1">
                                <div className="fw-bold">Address</div>
                                <div>{rolesData?.head_of_business}{rolesData?.head_of_business && ','}</div>
                                <div>{rolesData?.contact_details?.address?.plot_no}{rolesData?.contact_details?.address?.plot_no && ','}{rolesData?.contact_details?.address?.buildinghousenumber}{rolesData?.contact_details?.address?.buildinghousenumber && ','}{rolesData?.contact_details?.address?.buildingstreetname}{rolesData?.contact_details?.address?.buildingstreetname && ','}{rolesData?.contact_details?.address?.colonysector_arealocality}{rolesData?.contact_details?.address?.colonysector_arealocality && ','}{rolesData?.contact_details?.address?.villagetowncity}{rolesData?.contact_details?.address?.villagetowncity && ','}{rolesData?.contact_details?.address?.state}{rolesData?.contact_details?.address?.state && ','}{rolesData?.contact_details?.address?.country}{rolesData?.contact_details?.address?.country && ','}</div>
                                <div>{rolesData?.contact_details?.address?.postcode}{rolesData?.contact_details?.address?.postcode && '.'}</div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
            <h5 className="mt-3 mb-2 fw-bold">Roles And Privilege</h5>
            {loading && (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            )}
            {!loading && (<>{rolesData && rolesData?.roles?.length > 0 && rolesData?.roles?.map((value: any, index: any) => (<Accordion  key={index}>
                <Accordion.Item eventKey="0" className="mb-2">
                    <Accordion.Header><b>Role</b> : {value?.name}</Accordion.Header>
                    <Accordion.Body>
                        {value?.permissions?.length > 0 && value?.permissions?.map((permission: any, subIndex: any) => (
                            <div key={subIndex}><TiTick className="text-success me-1" size={20} /> <span className="fs-14">{permission?.replace(/_/g, " ")}</span></div>))}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>))}</>)}
            <Modal className="" show={show} onHide={closePopup} centered>
                <Modal.Body>
                    <div className="text-end"><i className="bi bi-x-lg"></i></div>
                    <img src={IMAGE_PATH +'/'+ rolesData?.bu_logo_image} style={{height:'300px'}} className="w-100"/>
                </Modal.Body>
            </Modal>
        </div>
    )
}